import { MAX_DEBUG_HISTORY_CALLS } from 'Modules/softphone/components/SoftphoneDevTools/constants';
import React from 'react';

/**
 * DebugAboutPanel - What the debug history contains and how long it is kept
 *
 * The retention line says "records", not "calls", because the cap counts
 * legs: a warm transfer is two and a four-party conference is five.
 */
export const DebugAboutPanel: React.FC = () => (
  <p className="rounded-[10px] border border-zinc-800 bg-zinc-900 p-3 text-[11.5px] leading-[1.6] text-zinc-400">
    Records are captured automatically when a call ends — one per leg, grouped
    as one interaction. {MAX_DEBUG_HISTORY_CALLS} records kept, in memory and in
    storage.
  </p>
);
